import { FC } from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { SxProps } from '@mui/material/styles';
import { getAlertStyles, getInfoIcon } from './helper';

interface IAlertProps extends AlertProps {
  borderRadius?: string;
  customStyles?: SxProps;
}

export const Alert: FC<IAlertProps> = ({
  variant = 'filled',
  severity,
  borderRadius,
  children,
  icon,
  customStyles,
  ...rest
}) => (
  <MuiAlert
    variant={variant}
    icon={icon || getInfoIcon[severity!]}
    sx={{
      borderRadius: borderRadius ?? '4px',
      p: 1,
      fontWeight: 400,
      ...(severity && { ...getAlertStyles[severity] }),
      ...customStyles,
    }}
    {...rest}
  >
    {children}
  </MuiAlert>
);
